module.exports = __webpack_public_path__ + "img/logo.e4dc4773.svg";